import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { SUPPORT_EMAIL } from "./config";
import AppStoreBadge from "./components/AppStoreBadge";

export default function MarketingFooter() {
  return (
    <footer className="mt-24 border-t border-[#E8E2D9] bg-[#FAF7F2]" data-testid="marketing-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <Logo variant="compact" size={32} />
          <p className="mt-4 text-[14px] text-[#57534E] leading-relaxed max-w-sm">
            The business workspace built for virtual assistants and independent
            service professionals.
          </p>
          <p className="mt-4 text-[13px] text-[#A8A29E]">
            Questions? <a className="text-[#E8712C] hover:underline" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </p>
          <AppStoreBadge source="footer" className="mt-5" />
        </div>

        <div>
          <h4 className="font-display text-[13px] uppercase tracking-wider text-[#1A2A3A] mb-3">Product</h4>
          <ul className="space-y-2 text-[14px] text-[#57534E]">
            <li><Link className="hover:text-[#E8712C]" to="/features">Features</Link></li>
            <li><Link className="hover:text-[#E8712C]" to="/how-it-works">How it works</Link></li>
            <li><Link className="hover:text-[#E8712C]" to="/pricing">Pricing</Link></li>
            <li><Link className="hover:text-[#E8712C]" to="/integrations">Integrations</Link></li>
            <li><Link className="hover:text-[#E8712C]" to="/product-tour">Product tour</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-[13px] uppercase tracking-wider text-[#1A2A3A] mb-3">Company</h4>
          <ul className="space-y-2 text-[14px] text-[#57534E]">
            <li><Link className="hover:text-[#E8712C]" to="/about">About</Link></li>
            <li><Link className="hover:text-[#E8712C]" to="/resources">Resources</Link></li>
            <li><Link className="hover:text-[#E8712C]" to="/faq">FAQ</Link></li>
            <li><Link className="hover:text-[#E8712C]" to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-[13px] uppercase tracking-wider text-[#1A2A3A] mb-3">Legal</h4>
          <ul className="space-y-2 text-[14px] text-[#57534E]">
            <li><Link className="hover:text-[#E8712C]" to="/privacy">Privacy</Link></li>
            <li><Link className="hover:text-[#E8712C]" to="/terms">Terms</Link></li>
            <li><Link className="hover:text-[#E8712C]" to="/data-deletion">Account deletion</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#E8E2D9]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-wrap items-center justify-between gap-3 text-[13px] text-[#A8A29E]">
          <div>© {new Date().getFullYear()} ClientDesk VA. All rights reserved.</div>
          <div>Made for people who serve clients.</div>
        </div>
      </div>
    </footer>
  );
}
